import React from 'react';
import { motion } from 'framer-motion';
import { Section, SectionTitle } from '@/components/shared/Section';
import { WOW_CONCEPTS } from '@/data/venddi';

export default function VenddiWow() {
  return (
    <Section>
      <SectionTitle
        badge="5 CONCEPTOS WOW"
        title="Las 5 cosas que Venddi hace y ningún otro POS"
        subtitle="No son features. Son diferenciadores que mueven la aguja del negocio."
        center
      />

      <div className="space-y-4 max-w-6xl mx-auto mt-10">
        {WOW_CONCEPTS.map((w, i) => (
          <motion.div
            key={w.num}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ delay: i * 0.05 }}
            className="group relative p-6 sm:p-8 rounded-2xl bg-gradient-to-br from-slate-50 to-white border border-slate-200 shadow-sm hover:shadow-xl hover:border-slate-300 transition-all overflow-hidden"
            data-testid={`wow-${w.num}`}
          >
            <div className="absolute top-0 right-0 w-40 h-40 rounded-full blur-3xl opacity-20 group-hover:opacity-40 transition-opacity" style={{ background: w.color }} />
            <div className="relative grid grid-cols-1 lg:grid-cols-[auto_1fr_auto] gap-6 items-center">
              {/* Left: number + icon + title block (fixed width on desktop for alignment) */}
              <div className="flex items-center gap-4 lg:gap-5 lg:w-[380px]">
                <div
                  className="text-6xl lg:text-7xl font-black tracking-tight shrink-0 leading-none select-none"
                  style={{ fontFamily: 'Syne,sans-serif', color: w.color, opacity: 0.25, fontVariantNumeric: 'tabular-nums' }}
                >
                  {w.num}
                </div>
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 shadow-md" style={{ background: w.color }}>
                  <w.icon className="w-7 h-7 text-white" strokeWidth={1.8} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg sm:text-xl font-bold text-[#0A2540] leading-tight" style={{ fontFamily: 'Syne,sans-serif' }}>{w.title}</h3>
                  <p className="text-xs sm:text-sm font-semibold mt-0.5" style={{ color: w.color }}>{w.subtitle}</p>
                </div>
              </div>

              {/* Middle: description (flex-grow to fill) */}
              <p className="text-sm text-slate-600 leading-relaxed">{w.desc}</p>

              {/* Right: metric box (fixed width for column alignment) */}
              <div className="lg:w-[170px] shrink-0 p-4 rounded-xl bg-white border border-slate-200 shadow-sm text-center">
                <div
                  className="text-3xl sm:text-4xl font-black leading-none tracking-tight"
                  style={{ color: w.color, fontFamily: 'Syne,sans-serif', fontVariantNumeric: 'tabular-nums' }}
                >
                  {w.metric}
                </div>
                <div className="text-[10px] text-slate-500 uppercase tracking-[0.12em] font-semibold mt-2 leading-tight">{w.metricLabel}</div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
